import { Component, EventEmitter, Input, OnChanges,
  Output, ViewChildren, QueryList, ChangeDetectorRef, SimpleChanges, OnInit, 
  OnDestroy,
  ViewChild,
  ElementRef} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiService } from '../../../../@core/service/api.service';
import { CompilationModel, PaymentPlan, PaymentPlanInvoice, PaymentPlanItem, ShipmentLineItem, SpoPayment } from '../../../../@models/erp/compilation';
import {  CompilationTypeData, CountryCodes, DeliveryConditionsData,
  Incoterms, SpoStatusData, TransportStatusData,
  UnitData, DocConfig, 
  FiscalYearData,
  Currency,
  InvoiceStatusData,
  InvoicePaymentData,
  PaymentDates} from '../../../../@models/erp/compilationData';
import { ETdsExportType, LineItemModel } from '../../../../@models/erp/lineItem';
import { DynamicTemplateDirective } from '../../../../@directives/dynamic-template.directive';
import { AuthGuardService } from '../../../../@core/service/auth-guard.service';
import { EContactType, FileModel } from '../../../../@models';
import { ChangelogEntry } from '../../shared/changelog/changelog.component';
import { TreeService } from '../../../../@core/service/tree.service';
import { getDocumentNumber, mongoId, toEUR, waitForVariable } from '../../../../@core/common/global';
import { SharedDataService } from '../../../../@core/service/shared-data.service';
import * as moment from 'moment';
import { DatePipe, formatDate } from '@angular/common';
import { NbDialogService } from '@nebular/theme';
import { CommonDialogComponent } from '../../shared/common-dialog/common-dialog.component';
import { DocumentComponent } from '../document.component';
import { defaultReport } from '../../reports/report-overview-fields';
import { Subscription } from 'rxjs';
import { DocMetrics } from '../line-item-container/line-item-metrics/line-item-metrics.component';
import { RoundPipe } from '../../../../@theme/pipes';
import { DownloadConfig } from '../document-printer/document-printer.component';
import * as saveAs from 'file-saver';
import { isValid } from 'date-fns';
import { ProfitMarginType } from '../payment-plan/profit-margin/profit-margin.component';
import { BarcodesComponent } from '../barcodes/barcodes.component';

@Component({
  selector: 'ngx-document-sub-components',
  templateUrl: './document-sub-components.component.html',
  styleUrls: ['./document-sub-components.component.scss'],
})
export class DocumentSubComponentsComponent implements OnInit, OnChanges {
  @Input() compilation: CompilationModel;
  @Input() documentComponent: DocumentComponent;

  @Input() locked: boolean = false;
  @Input() relatedDocuments: any;
  @Input() print: boolean = false;
  @Input() single: string = null;
  @Input() disabled = false; // not to confuse with isDisabled()
  @Output() documentChange = new EventEmitter<string>();

  @ViewChildren(DynamicTemplateDirective) templateRefs: QueryList<DynamicTemplateDirective>;
  @ViewChild('qrcode') qrcode: BarcodesComponent;

  countryCodeOptions = CountryCodes.getOptions();
  deliveryConditionOptions = DeliveryConditionsData.getOptions();
  incotermsOptions = Incoterms.getOptions();
  taxHintOptions = this.data.compilationData?.taxHintStore?.map(m => ({ id: m, name: m }))
  fiscalYearOptions = FiscalYearData.getOptions();
  currencyOptions = Currency.getOptions();
  profitMarginType = ProfitMarginType;
  meansOfTransportOptions: { id: string, name: string }[];


  // associatedSpos = [];
  linkedOCs = [];
  obicUnitQuantity = null;
  obicQuantity = null;
  spoUnitQuantity = null;
  spoQuantity = null;

  unitData = UnitData;
  transportStatusData = TransportStatusData;
  spoStatusData = SpoStatusData;
  object = Object;
  typeData = CompilationTypeData;
  paymentDates = PaymentDates.getOptions();
  term = console;

  relatedDocumentsData = [];

  paymentPlan: PaymentPlan;

  // pfspoSelectorData = [];

  totalNetWeight = null;
  totalGrossWeight = null;

  grossWeight = null;

  sections = [];
  visibleSections: any;

  accountManager = '';

  clCount = 0;

  templates = [];

  boxData = { ret: [], totalCount: 0};

  config = DocConfig;

  private static boxesCache = {};

  protected barcodeModel = { doc: [], items: [[]] };

  invoiceAddress = '';

  // coverSheetSpos: { spos: any, sumQ: number } = { spos: [], sumQ: 0 };

  isScreen = (section) => !this.print;

  isPrint = (section: any) => {
    if (!this.print || !section.checked) return false;

    switch (section.name) {
      case 'associatedPfspoList':
        return this.tree.getAssociatedPfspos(this.compilation.type, true) && this.tree.getAssociatedPfspos(this.compilation.type, true).length > 0;
      case 'associatedOCList': return this.tree.getRelatedOCs() && this.tree.getRelatedOCs().length > 0;
      case 'termsOfPayment': return this.compilation && this.compilation.paymentPlan;
      case 'testCertificates': return this.compilation?.testCertificates?.length;
      case 'tcFromPfspo': return this.tree.linkedPfspos?.reduce((a, c) => [...a, ...c?.testCertificates], [])?.length;
      case 'technicalDatasheetPdf':
        const tdsa = this.compilation && this.compilation.lineItems.map(m => this.getTDS(m));
        const tds = tdsa && tdsa.reduce((a, c) => c && [...a, ...c], []);
        return tds && tds.length;
      case 'finishedProductPdf': return this.compilation && this.compilation.lineItems && this.compilation.lineItems.length > 0;
      case 'changelogFiles':
        const clsa = this.compilation && this.compilation.changelog && (this.compilation.changelog as ChangelogEntry[]).map(cl => cl.files);
        const clsf = clsa && clsa.filter(f => f && f.length);
        const cls = clsf && clsf.reduce((a, c) => c && [...a, ...c], []);
        return cls && cls.length;
      case 'trackSpoPayment':
        return this.compilation.spoPayment?.length > 0;
      case 'weightSection':
        return this.totalGrossWeight && this.totalNetWeight;
      case 'transportation':
        return !this.compilation.invoiceType || this.compilation.invoiceType !== 'service';
      case 'dnBoxes':
        return this.boxData?.totalCount > 0;
      case 'invoiceAddress':
        return this.invoiceAddress?.length > 0;
      case 'changelogLite':
      case 'obicSummary':
      case 'ocSummary':
      case 'coverSheet':
      case 'issuerFooter':
      case 'goodsReceived':
      case 'sendToSection':
      case 'qrcode':
        return true;
    }

    return this.compilation[section.name];
  }

  isVisible = (section: any) => this.compilation?.visibleFields?.includes(section.name);

  isDisabled = (section: any) => (section.disabled === true || this.locked || !this.isVisible(section)
    || (section.readonly && section.readonly.includes(CompilationTypeData.get(this.compilation.type).code))) && !section.forceEnabled;

  isDocSection = (section: any) => this.visibleSections && this.visibleSections.map(m => m.key).includes(section.name);

  getDocType = (type: number | string) => CompilationTypeData.get(+type);

  boxConfig = [
    // { name: 'palletId', header: 'Pallet ID', align: 'center' },
    { name: 'boxId', header: 'Box ID', align: 'center' },
    { name: 'boxNr', header: 'Box #', align: 'center' },
    { name: 'lot', header: 'Lot #' },
    { name: 'quantity', header: 'Q', align: 'right' },
    { name: 'tc', header: 'TC #' },
    { name: 'prodDate', header: 'Prod Date', align: 'center' },
    { name: 'shelfLifeText', header: 'Shelf Life Text', width: 'auto' },
    // { name: 'oc', header: 'OC #' },
    // { name: 'dn', header: 'DN #' },
    // { name: 'dnPos', header: 'DN/OC Pos', align: 'center' },
    // { name: 'dnRecipient', header: 'DN/OC Customer' },
    { name: 'dispatchDate', header: 'Dispatch Date', align: 'center' },
    // { name: 'dnCalcCode', header: 'DN/OC Product #' },
    // { name: 'dnDimensions', header: 'DN/OC Product Dimensions' },
    { name: 'customerProductCode', header: 'Cust Prod Code' },
    { name: 'customerProductName', header: 'Cust Prod Name' },
  ]

  constructor(
    private domSanitizer: DomSanitizer,
    public api: ApiService,
    public auth: AuthGuardService,
    private cdRef: ChangeDetectorRef,
    public tree: TreeService,
    public data: SharedDataService,
    private datePipe: DatePipe,
    private dialog: NbDialogService,
  ) { }

  // tev = null;
  // ngOnInit(): void {
  //   this.tev = this.tree.documentTreeLoadedEvent.subscribe(t => {
  //     this.associatedSpos = this.tree.getAssociatedPfspos(this.compilation.type);
  //     console.log('>>> spos', this.associatedSpos);
  //     if (this.tree.linkedObic) {
  //       this.obicQuantity = this.tree.linkedObic.lineItems.reduce((a, c) => a + c.quantity, 0);
  //       this.spoQuantity = this.associatedSpos.reduce((a, c) => a + c.quantity, 0);
  //     }
  //   })
  // }

  // ngOnDestroy(): void {
  //   this.tev.unsubscribe
  // }

  ngOnInit() {
    this.data.loadUsers();

    this.data.loadCompilationData().then(() => {
      if (!this.data.compilationData.meansOfTransportStore) this.data.compilationData.meansOfTransportStore = [];
      if (!this.data.compilationData.termsOfPaymentStore) this.data.compilationData.termsOfPaymentStore = [];
      this.meansOfTransportOptions = this.data.compilationData.meansOfTransportStore.map(m => ({id: m, name: m}));
    });
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes.compilation) {

      if (!this.compilation.visibleFields) this.compilation.visibleFields = [];
      DocConfig.getArray().forEach(el => {
        if (el.value.index > 0 && el.value['forceEnabled']) {
          if (this.compilation.visibleFields.indexOf(el.key) < 0) {
            this.compilation.visibleFields.push(el.key);
          }
        }
      })
      this.visibleSections = DocConfig.getArray()
        .filter(f => (!(f.value as any).hideOnNonDocs
          || ((f.value as any).docs
            && (f.value as any).docs.indexOf(CompilationTypeData.get(this.compilation.type).code) >= 0
          ))
        )
      await waitForVariable(this, 'templateRefs');
      for (const section of ['text', ...this.visibleSections.map(s => s.key)]) {
        const refs = this.templateRefs && this.templateRefs.toArray().find(x => x.name === section);
        if (refs && refs.template) this.templates[section] = refs.template
      }

      this.totalGrossWeight = this.compilation.packingConditions?.reduce((a, c) => a + (c.weightOverride || c.weight), 0);
      this.totalNetWeight = this.compilation.packingConditions?.reduce((a, c) => a + c.netWeight, 0);

      // if (this.compilation.meansOfTransport && !this.compilation.visibleFields.includes('transportation')) {
      //   this.compilation.visibleFields.push('transportation');
      // }

      // const associatedSpos = this.compilation.lineItems.reduce((a, c) => [...a, ...(c?.pfspo ?? [])], []);
      // console.log('===> ', associatedSpos);
      // this.coverSheetSpos = {
      //   spos: associatedSpos,
      //   sumQ: associatedSpos.reduce((a, c) => a + (+c.quantity), 0),
      // }
      const recipient = this.data.businesses.find(f => mongoId(f) === mongoId(this.compilation.recipient));
      const contact = recipient?.contacts.find(f => f.type === EContactType.Invoice);
      const fields = DocConfig.get('defaultAddress').fields

      if (contact) {
        this.invoiceAddress = (contact.addressName || contact.title) + ', ';
        for (const field of fields) {
          if (contact.fields.find(f => f.type === field.field)) {
            this.invoiceAddress += `${contact.fields.find(f => f.type === field.field).value}, `;
          }
        }
        this.invoiceAddress = this.invoiceAddress.replace(/,[^\w\d]*$/, '');
        // this.invoiceAddress = this.invoiceAddress.slice(0, -5);
      }


      // if (DocConfig.get('boxes').docs?.includes(CompilationTypeData.get(this.compilation.type).code)) {
      if (CompilationTypeData.get(this.compilation.type).code === 'DN') {
        const config = { boxes: {
          placeOfLoading: null,
          customers: [],
          dnRecipients: [],
          baseProducts: [],
          finishedProducts: [],
          suppliers: [],
          date: new Date(),
          dateType: 13,
          dateFrom: -1,
          dateTo: -1,
          stockStatus: { notInInventory: false, onStock: false, shipped: false },
          sort: 1,
          expiryReport: false,
          withOCBoxPrice: true,
          simple: true,
          doc: null,
          dn: this.compilation.code,
          nameOverride: '',
          withEnRoute: false,
          extended: 0
        }}
        if (this.print) {
          this.boxData = DocumentSubComponentsComponent.boxesCache[this.compilation.code];
          if (this.boxData?.ret?.some(b => b.shelfLifeDate)) {
            const prodColIdx = this.boxConfig.findIndex(f => f.name === 'prodDate');
            // this.boxConfig[prodColIdx].width = '3rem'; 
            this.boxConfig.splice(prodColIdx + 1, 0, { name: 'shelfLifeDate', header: 'Expiry', align: 'center' })
            // this.boxConfig[prodColIdx + 1].width = '3rem';
            // this.boxConfig.find(f => f.name === 'dispatchDate').width = '3rem';

          }

        } else if (this.compilation.packingConditions?.length) {
          this.api.getDocumentReport('boxes', config, false).subscribe(boxes => {
            this.boxData = boxes;
            console.log('******boxdata', this.boxData);
            this.boxData.ret?.forEach((el, idx) => {
              this.boxData.ret[idx].dispatchDate = el.dispatchDate?.replace(/T.*/, '');
              if (el.customerProductName?.length > 20) {
                this.boxData.ret[idx].customerProductName = el.customerProductName.slice(0,20) + '…';
              }
            })
            if (boxes.ret?.some(b => b.shelfLifeDate)) {
              const prodColIdx = this.boxConfig.findIndex(f => f.name === 'prodDate');
              this.boxConfig.splice(prodColIdx + 1, 0, { name: 'shelfLifeDate', header: 'Expiry', align: 'center' })
            }
            DocumentSubComponentsComponent.boxesCache[this.compilation.code] = this.boxData;
            console.log('this.boxData', this.boxData);
          })
        } else {
          this.boxData = DocumentSubComponentsComponent.boxesCache[this.compilation.code] = { ret: [], totalCount: 0 }
        }
      }

      // TODO: this is the same as this.linkedOCs = await this.api.getRelatedOcs(this.compilation.code);, so get rid of it
      if (this.compilation.code) for (let i = 0; i <this.compilation.lineItems?.length; i++) {
        const li = this.compilation.lineItems[i];
        const spoOcMap = await this.api.getCachedSpoOcMap(this.compilation.code, li.position.internalPos);
        const relatedOCs = 
        li.relatedOCs = spoOcMap?.map(m => ({
          parentPos: m.parentPos,
          pos: m.pos+1,
          quantity: +m.quantity || 0,
          doc: JSON.parse(JSON.stringify(m.doc)),
        }));
        // console.log('===>relatedOCs0', this.pfspo.doc, this.lineItem.relatedOCs);
        // if (!li.relatedOCs?.find(f => f.doc.code === this.compilation.code)) {
        //   this.addOC(this.lineItem, { ocPos: this.ocPosition+1, code: this.compilation.code})
        // }
      }
      this.linkedOCs = await this.api.getRelatedOcs(this.compilation.code);
    }
  }

  getSection(section: string) {
    if (!this.sections[section]) {
      this.sections[section] = DocConfig.get(section);
      this.sections[section].name = section;
    }
    this.sections[section].checked = this.single ? section === this.single : this.isVisible(this.sections[section]);
    return this.sections[section];
  }

  doHide(section: any) {
    const ret = section && section.hideOnNonDocs && !section.docs.includes(CompilationTypeData.get(this.compilation.type).code);
    return ret === true;
  }

  getRelatedDocumentsData(docs) {
    // const ret = docs.map(m => {
    //   const match = m.text.match(/([^(]*)(.(.*).)?/);
    //   const doc = match && match[1];
    //   const date = match && match[3];
    //   return { doc: doc, date: date };
    // })
    const ret = docs.map(m => {
      const doc = getDocumentNumber(m.doc);
      const date = moment(m.doc.issueDate).format('YYYY-MM-DD');
      const customerDoc = (['OR', 'FCOR'].includes(CompilationTypeData.get(m.doc.type).code) && m.doc.customerDocumentNumber) || '';
      const customerDate = (['OR', 'FCOR'].includes(CompilationTypeData.get(m.doc.type).code) && m.doc.customerDocumentDate) || '';
      return { doc: doc, date: date, customerDoc, customerDate };
    })

    // TODO: why is this hack necceserry to enable selecting related documents text?
    // --> change detection / async / onChanges...
    if (JSON.stringify(ret) !== JSON.stringify(this.relatedDocumentsData)) {
      this.relatedDocumentsData = ret;
    }
    return this.relatedDocumentsData;
  }

  getAssociatedSpos() {
    const associatedSpos = this.tree.getAssociatedPfspos(this.compilation.type, true);
    if (this.tree.linkedObic) {
      this.obicUnitQuantity = this.tree.linkedObic.lineItems.reduce((a, c) => a + c.displayUnitQuantity, 0);
      this.obicQuantity = this.tree.linkedObic.lineItems.reduce((a, c) => a + c.quantity, 0);
      this.spoUnitQuantity = associatedSpos?.reduce((a, c) => a + c.unitQuantity, 0);
      this.spoQuantity = associatedSpos?.reduce((a, c) => a + c.quantity, 0);
    }
    return associatedSpos;
  }

  sanitize(value: string) {
    return value && this.domSanitizer.bypassSecurityTrustHtml(value.replace(/\n/g, '<br>'));
  }

  checkedFiles(files: FileModel[]) {
    return files && files.filter(f => f.checked);
  }

  removeFile(files: any, file: FileModel) {
    return files.filter(f => f.url !== file.url);
  }

  getCLDNum(lidx, idx) {
    let ct = 0;
    if (this.compilation.changelog) for (let l = 0; l < this.compilation.changelog.length; l++) {
      const item = this.compilation.changelog[l] as any;
      if (item && item.files) for (let i = 0; i < item.files.length; i++) {
        if (item.files[i].checked) {
          ct++;
          if (lidx === l && idx === i) return ct;
        }
      }
    }
  }

  showEnclosures() {
    if (!this.print) return true;
    if (this.single) {
      return this.single === 'documents'
      || this.single === 'technicalDatasheetPdf'
      || this.single === 'testCertificates'
      || this.single === 'finishedProductPdf'
      || this.single === 'changelogFiles'
    }
    return this.compilation.visibleFields.includes('documents')
      || this.compilation.visibleFields.includes('technicalDatasheetPdf')
      || this.compilation.visibleFields.includes('testCertificates')
      || this.compilation.visibleFields.includes('finishedProductPdf')
      || this.compilation.visibleFields.includes('changelogFiles')
  }

  toggleItem(section) {
    if (!section.checked) {
      section.checked = true;
      if (!this.compilation.visibleFields.includes(section.name)) this.compilation.visibleFields.push(section.name);
    } else {
      section.checked = false;
      this.compilation.visibleFields = this.compilation.visibleFields.filter(f => f !== section.name);
    }
  }

  setCurrentDocumentByCode(code: string) {
    this.documentChange.emit(code);
  }

  getTDS(lineItem: LineItemModel) {
    const bp = lineItem && lineItem.finishedProduct && lineItem.finishedProduct.product;
    const tds = (bp && bp.technicalDatasheets) || [];
    if (!lineItem.technicalDatasheets || !lineItem.technicalDatasheets.length) {
      lineItem.technicalDatasheets = tds.map(() => ETdsExportType.none);
    }
    return tds;
  }

  async changelogUploadCompleted() {
    if (this.compilation && this.compilation._id) {
      await this.api.updateField(this.compilation._id, 'changelog', this.compilation.changelog);
    }
  }

  getSumAssignedQ(item: LineItemModel) {
    return item.pfspo.reduce((a, c) => a + (+c.quantity), 0);
  }

  getIssuer() {
    return this.compilation.issuerAddress && this.compilation.issuerAddress.replace(/\n.*/g, '');
  }

  getBusinessUnits() {
    const products = this.compilation?.lineItems?.map(m => m.finishedProduct?.product).filter(notNull => notNull);
    const businessUnits = products?.map(m => m.businessUnit?.name);
    const set = Array.from(new Set(businessUnits));
    // console.log('==>', products, businessUnits, set);
    return set.join(', ');
  }

  getIssuedBy() {
    return this.data.users.find(f => mongoId(f) === mongoId(this.compilation.issuedBy))?.name || '';
  }

  showUpdatePackingConditions() {
    // TODO: only show button if PL data !== DN data
    return this.compilation.type === CompilationTypeData.get('DN').id && !this.locked;
  }

  updatePackingConditions() {
    const pl = this.tree.findDocByUpstreamType(this.compilation, 'PL');
    this.compilation.packingConditions = pl.packingConditions;
  }

  addSpoPaymentItem() {
    if (!this.compilation.spoPayment) this.compilation.spoPayment = [];
    const spoPaymentItem = new SpoPayment();
    this.compilation.spoPayment.push(spoPaymentItem);
  }
  removeSpoPayment(idx: number) {
    this.compilation.spoPayment.splice(idx, 1);
  }
  getSpoPaymentTotal() {
    const fxs = this.data.compilationData.currency?.sort((a,b) => a.validFrom < b.validFrom ? 1 : -1)
    // const fx = fxs.find(f => f.validFrom < c?.date) || fxs[0];
    // const netEur = c?.currency.toLowerCase() === 'eur' ? c.net : (c ? c.net / +fx[c.currency.toLowerCase()] : 0);
    const ret = this.compilation.spoPayment?.reduce((a, c) => { 
      const fx = fxs.find(f => f.validFrom < (c?.paymentDate || c?.spInvoiceDate)) || fxs[0];
      const netEUR = (c?.currency ?? this.compilation.currency)?.toLowerCase() !== 'eur' ? (c?.spInvoiceValue ? c.spInvoiceValue / +fx[c.currency?.toLowerCase()] : 0) : c.spInvoiceValue ?? 0;
      return a + netEUR; 
    }, 0) || 0;
    return ret;
  }
  getSpoPaymentDiff() {
    const fxs = this.data.compilationData.currency?.sort((a,b) => a.validFrom < b.validFrom ? 1 : -1)
    // const fx = fxs.find(f => f.validFrom < c?.date) || fxs[0];
    // const netEur = c?.currency.toLowerCase() === 'eur' ? c.net : (c ? c.net / +fx[c.currency.toLowerCase()] : 0);
    const subtotal = this.compilation.spoPayment?.reduce((a, c) => { 
      const fx = fxs.find(f => f.validFrom < (c?.paymentDate || c?.spInvoiceDate)) || fxs[0];
      const netEUR = (c?.currency ?? this.compilation.currency)?.toLowerCase() !== 'eur' ? (c?.spInvoiceValue ? c.spInvoiceValue / +fx[c.currency?.toLowerCase()] : 0) : c.spInvoiceValue ?? 0;
      return a + netEUR; 
    }, 0) || 0;
    // const subtotal = this.compilation.spoPayment?.reduce((a, c) => a + (+c.spInvoiceValue), 0) || 0;
    const total = this.compilation.shipmentLineItems?.reduce((a, c) => a + c?.document?.lineItems?.reduce((la, lc) => {
      const fx = fxs.find(f => f.validFrom < (c.document.vieDispatchDate)) || fxs[0];
      const ret = la + (c?.document?.currency?.toLowerCase() !== 'eur' ? (c ? lc.piecePrice*lc.quantity / +fx[c?.document?.currency?.toLowerCase()] : 0) : +lc.piecePrice*lc.quantity);
      return ret;
    }, 0), 0);
    return (total || this.data.totalNet) - subtotal; //this.data.totalNet - subtotal;
  }
  async saveSpoPaymentUpload(spoin: SpoPayment, files: FileModel[], idx: number, variant: number) {
    console.log('file', files?.[0]);
    // this.dialog.open(CommonDialogComponent, {
    //   closeOnBackdropClick: false,
    //   context: {
    //     header: 'Reminder',
    //     message: 'Don\'t forget to save the Document to make the file upload persistant',
    //   },
    // })
    if (files?.[0] && variant > 0) {
      const doc = await this.api.loadCompilation(mongoId(this.compilation));
      if (variant === 1 && doc.spoPayment?.[idx]) {
        doc.spoPayment[idx].spoInvoiceUpload = files[0];
      } else if (variant === 2 && doc.spoPayment?.[idx]) {
        doc.spoPayment[idx].transactionReceipt = files[0];
      }
      this.api.saveCompilation(doc);
    }
  }

  getFiscalYear() {
    return this.fiscalYearOptions.find(f => +f.id === +this.compilation.fiscalYear)?.name
  }

  onMeansOfTransportChanged(transport: string) {
    this.compilation.meansOfTransport = transport;
    this.data.setCSIdentifier(this.compilation);
  }
  async addMeansOfTransport() {
    await this.api.saveCompilationData('meansOfTransportStore', this.compilation.meansOfTransport, true);
    await this.data.reloadCompilationData();
    this.meansOfTransportOptions = this.data.compilationData.meansOfTransportStore.map(m => ({id: m, name: m}));
  }
  async removeMeansOfTransport() {
    await this.api.saveCompilationData('meansOfTransportStore', this.compilation.meansOfTransport, false);
    await this.data.reloadCompilationData();
    this.meansOfTransportOptions = this.data.compilationData.meansOfTransportStore.map(m => ({id: m, name: m}));
  }

  getSectionLabel(label: string | { rx: RegExp, text: string }[]) {
    if (Array.isArray(label)) for (const i of label) {
      if ((i.rx).test(this.compilation.code)) return i.text;
    } else {
      return label;
    }
  }

  dnBoxesPageSize = 25;
  get dnBoxesPageCount(): number {
    // console.log('Math.ceil(this.boxData.totalCount / this.dnBoxesPageSize)', Math.ceil(this.boxData.totalCount / this.dnBoxesPageSize))
    return Math.ceil(this.boxData.totalCount / this.dnBoxesPageSize);
  }

  dnBoxesPageRows(pageIndex: number) {
    const start = pageIndex * this.dnBoxesPageSize;
    // console.log('dnBoxesPageRows', start, start + this.dnBoxesPageSize, this.boxData.ret.slice(start, start + this.dnBoxesPageSize))
    return this.boxData.ret.slice(start, start + this.dnBoxesPageSize);
  }

  copyObicSummaryToClipboard() {

  //   <table class="nrk-table w-100">
  //   <tr>
  //     <th style="text-align:left;padding-left:10pt">SPO #</th>
  //     <th style="text-align:left">OBIC #</th>
  //     <th style="text-align:center" title="partial deliveries">PD</th>
  //     <th style="text-align:center">EXW date</th>
  //     <th style="text-align:center">Arrival date</th>
  //     <th style="text-align:center">PFSPO status</th>
  //     <th style="text-align:center">Transport status</th>
  //     <th style="text-align:right">Q/unit</th>
  //     <th style="text-align:right;padding-right:10px">Q/pc.</th>
  //   </tr>
  //   <tr *ngFor="let doc of getAssociatedSpos(); index as idx">
  //     <td style="text-align:left;padding-left:10pt">{{ doc.doc | documentNumber : null : false : true }}</td>
  //     <td style="text-align:left">{{doc.doc?.lineItems && doc.doc.lineItems[0].tbCode || 'no obic'}}</td>
  //     <td style="text-align:center">{{idx+1}}/{{getAssociatedSpos().length}}</td>
  //     <td style="text-align:center" style="white-space:nowrap">{{ doc.doc?.exwJapanDate | date : 'yy-MM-dd' }}</td>
  //     <td style="text-align:center" style="white-space:nowrap">{{ doc.doc?.arrivingVieDate | date : 'yy-MM-dd' }}</td>
  //     <td style="text-align:center">{{ spoStatusData.get(doc.doc?.transportRun?.spoStatus)?.name }}</td>
  //     <td style="text-align:center">{{ transportStatusData.get(doc.doc?.transportRun.transportStatus)?.name }}</td>
  //     <td style="text-align:right">{{ doc.unitQuantity }}</td>
  //     <td style="text-align:right;padding-right:10pt">{{ doc.quantity }}</td>
  //   </tr>
  //   <tr style="color:gray">
  //     <td style="text-align:right" colspan="7">OBIC:</td><td style="text-align:right">{{obicUnitQuantity}}</td><td style="text-align:right;padding-right:10pt">{{obicQuantity}}</td>
  //   </tr>
  //   <tr style="color:gray">
  //     <td><button class="nrk-button" (click)="copyObicSummaryToClipboard()">copy to clipboard</button></td>
  //     <td style="text-align:right" colspan="6">(PF)SPOs:</td><td style="text-align:right">{{spoUnitQuantity}}</td><td style="text-align:right;padding-right:10pt">{{spoQuantity}}</td>
  //   </tr>
  //   <tr [style]="'color:gray;' + (obicQuantity-spoQuantity < 0 ? 'border:2px solid red' : 'font-style:italic' )">
  //     <td style="text-align:right" colspan="7">diff:</td><td style="text-align:right">{{obicUnitQuantity-spoUnitQuantity}}</td><td style="text-align:right;padding-right:10pt">{{obicQuantity-spoQuantity}}</td>
  //   </tr>
  // </table>


    // const header = 'SPO #\tOBIC #\tPD\tEXW date\tArrival date\tPFSPO status\tTransport status\tQ/unit\tQ/pc.\n';
    // let rows = '';
    // this.getAssociatedSpos().forEach((doc, idx) => {
    //   // <td style="text-align:left;padding-left:10pt">{{ doc.doc | documentNumber : null : false : true }}</td>
    //   // <td style="text-align:left">{{doc.doc?.lineItems && doc.doc.lineItems[0].tbCode || 'no obic'}}</td>
    //   // <td style="text-align:center">{{idx+1}}/{{getAssociatedSpos().length}}</td>
    //   // <td style="text-align:center" style="white-space:nowrap">{{ doc.doc?.exwJapanDate | date : 'yy-MM-dd' }}</td>
    //   // <td style="text-align:center" style="white-space:nowrap">{{ doc.doc?.arrivingVieDate | date : 'yy-MM-dd' }}</td>
    //   // <td style="text-align:center">{{ spoStatusData.get(doc.doc?.transportRun?.spoStatus)?.name }}</td>
    //   // <td style="text-align:center">{{ transportStatusData.get(doc.doc?.transportRun.transportStatus)?.name }}</td>
    //   // <td style="text-align:right">{{ doc.unitQuantity }}</td>
    //   // <td style="text-align:right;padding-right:10pt">{{ doc.quantity }}</td>
    //   rows += `${getDocumentNumber(doc.doc)}\t`
    //     + `${doc.doc?.lineItems && doc.doc.lineItems[0].tbCode || 'no obic'}\t`
    //     + `${idx+1}/${this.getAssociatedSpos().length}\t`
    //     + `${this.datePipe.transform(doc.doc?.exwJapanDate, 'yy-MM-dd')}\t`
    //     + `${this.datePipe.transform(doc.doc?.arrivingVieDate, 'yy-MM-dd')}\t`
    //     + `${SpoStatusData.get(doc.doc?.transportRun?.spoStatus)?.name}\t`
    //     + `${TransportStatusData.get(doc.doc?.transportRun.transportStatus)?.name }\t`
    //     + `${doc.unitQuantity}\t`
    //     + `${doc.quantity}\n`
    // });
    // rows += `\t\t\t\t\t\tOBIC:\t${this.obicUnitQuantity}\t${this.obicQuantity}\n`
    //   + `\t\t\t\t\t\t(PF)SPOs:\t${this.spoUnitQuantity}\t${this.spoQuantity}\n`
    //   + `\t\t\t\t\t\tdiff:\t${this.obicUnitQuantity - this.spoUnitQuantity}\t${this.obicQuantity - this.spoQuantity}\n`


    // let html = `<html><head><style>
    //     table { border-collapse:collapse } 
    //     th { background-color: #ddd }
    //     td, th { border:1px solid black;padding: 0.5em 1em }
    //   </style></head><body>
    //     <div style="margin: 0 0 5pt 5pt"><b>OBIC summary ${this.compilation.lineItems[0]?.tbCode || ''}</b></div>
    //     <table>
    //       <tr>
    //         <th style="text-align:left;padding-left:10pt">SPO #</th>
    //         <th style="text-align:left">OBIC #</th>
    //         <th style="text-align:center" title="partial deliveries">PD</th>
    //         <th style="text-align:center">EXW date</th>
    //         <th style="text-align:center">Arrival date</th>
    //         <th style="text-align:center">PFSPO status</th>
    //         <th style="text-align:center">Transport status</th>
    //         <th style="text-align:right">Q/unit</th>
    //         <th style="text-align:right;padding-right:10px">Q/pc.</th>
    //       </tr>`

    // this.getAssociatedSpos().forEach((doc, idx) => {
    //   html += `
    //     <tr>
    //       <td style="border:1px solid black;text-align:left;padding-left:10pt">${getDocumentNumber(doc.doc, null, false, false)}</td>
    //       <td style="text-align:left">${doc.doc.lineItems[0]?.tbCode || 'no obic'}</td>
    //       <td style="text-align:center">${idx+1}/${this.getAssociatedSpos().length}</td>
    //       <td style="text-align:center" style="white-space:nowrap">${this.datePipe.transform(doc.doc?.exwJapanDate, 'yy-MM-dd')}</td>
    //       <td style="text-align:center" style="white-space:nowrap">${this.datePipe.transform(doc.doc?.arrivingVieDate, 'yy-MM-dd')}</td>
    //       <td style="text-align:center">${SpoStatusData.get(doc.doc?.transportRun?.spoStatus)?.name}</td>
    //       <td style="text-align:center">${TransportStatusData.get(doc.doc?.transportRun.transportStatus)?.name }</td>
    //       <td style="text-align:right">${doc.unitQuantity ?? ''}</td>
    //       <td style="text-align:right;padding-right:10pt">${doc.quantity ?? ''}</td>
    //     </tr>`
    // });

    // html += `
    //     <tr style="color:gray">
    //       <td style="text-align:right" colspan="7">OBIC:</td><td style="text-align:right">${this.obicUnitQuantity ?? 0}</td><td style="text-align:right;padding-right:10pt">${this.obicQuantity ?? 0}</td>
    //     </tr>
    //     <tr style="color:gray">
    //       <td style="text-align:right" colspan="7">(PF)SPOs:</td><td style="text-align:right">${this.spoUnitQuantity ?? 0}</td><td style="text-align:right;padding-right:10pt">${this.spoQuantity ?? 0}</td>
    //     </tr>
    //     <tr>
    //       <td style="text-align:right" colspan="7">diff:</td><td style="text-align:right">${this.obicUnitQuantity ?? 0 - this.spoUnitQuantity ?? 0}</td><td style="text-align:right;padding-right:10pt">${this.obicQuantity ?? 0 - this.spoQuantity ?? 0}</td>
    //     </tr>
    //   </table></body></html>`

    // html = '';


    let html = `
    <div>
      <div><b>OBIC summary ${this.compilation.lineItems[0]?.tbCode || ''}</b></div>
      <div>&nbsp;</div>
      <table cellspacing="0" style="border-collapse:collapse;">
        <tr>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">SPO #</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">OBIC #</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">PD</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">EXW date</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">ETA AT date</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">PFSPO status</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">Transport status</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">Q/unit</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">Q/pc.</th>
        </tr>`

        this.getAssociatedSpos().forEach((doc, idx) => {
          html += `
            <tr style="border: 1px solid black">
              <td style="border:1px solid black;text-align:left;padding:5px">${getDocumentNumber(doc.doc, null, false, false)}</td>
              <td style="border:1px solid black;text-align:left;padding:5px">${doc.doc.lineItems[0]?.tbCode || ''}</td>
              <td style="border:1px solid black;text-align:center;padding:5px">${idx+1}/${this.getAssociatedSpos().length}</td>
              <td style="border:1px solid black;text-align:center;padding:5px;white-space:nowrap">${this.datePipe.transform(doc.doc?.exwJapanDate, 'yy-MM-dd')}</td>
              <td style="border:1px solid black;text-align:center;padding:5px;white-space:nowrap">${this.datePipe.transform(doc.doc?.arrivingVieDate, 'yy-MM-dd')}</td>
              <td style="border:1px solid black;text-align:center;padding:5px">${SpoStatusData.get(doc.doc?.transportRun?.spoStatus)?.name}</td>
              <td style="border:1px solid black;text-align:center;padding:5px">${TransportStatusData.get(doc.doc?.transportRun.transportStatus)?.name }</td>
              <td style="border:1px solid black;text-align:right;padding:5px">${doc.unitQuantity ?? ''}</td>
              <td style="border:1px solid black;text-align:right;padding:5px">${doc.quantity ?? ''}</td>
            </tr>`
        });
    
        html += `
        <tr style="color:gray">
          <td style="text-align:right" colspan="7">OBIC:</td><td style="padding:5px;text-align:right">${this.obicUnitQuantity ?? 0}</td><td style="text-align:right;padding:5px">${this.obicQuantity ?? 0}</td>
        </tr>
        <tr style="color:gray">
          <td style="text-align:right" colspan="7">(PF)SPOs:</td><td style="padding:5px;text-align:right">${this.spoUnitQuantity ?? 0}</td><td style="text-align:right;padding:5px">${this.spoQuantity ?? 0}</td>
        </tr>
        <tr>
          <td style="text-align:right" colspan="7">diff:</td><td style="padding:5px;text-align:right">${(this.obicUnitQuantity ?? 0) - (this.spoUnitQuantity ?? 0)}</td><td style="text-align:right;padding:5px">${(this.obicQuantity ?? 0) - (this.spoQuantity ?? 0)}</td>
        </tr>
      </table>
    </div>`

    this.data.copyHtmlToClipboard(html);

  }

  copyOcSummaryToClipboard() {

    let html = `
    <div>
      <div><b>OC summary</b></div>
      <div>&nbsp;</div>
      <table cellspacing="0" style="border-collapse:collapse;">
        <tr>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">OC #</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">PO #</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">POS</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">QTY PC</th>
          <th style="background-color: lightgray;border:1px solid black;padding:5px">CRDD</th>
        </tr>`

        // this.compilation.lineItems.forEach((li, idx) => {
        //   li.relatedOCs.forEach(doc => {
        //   html += `
        //     <tr style="border: 1px solid black">
        //       <td style="border:1px solid black;text-align:left;padding:5px">${getDocumentNumber(doc.doc, null, false, false)}</td>
        //       <td style="border:1px solid black;text-align:left;padding:5px">${doc.doc.customerDocumentNumber || ''}</td>
        //       <td style="border:1px solid black;text-align:center;padding:5px">${li.position.posOverride ?? idx+1}</td>
        //       <td style="border:1px solid black;text-align:right;padding:5px">${doc.quantity ?? ''}</td>
        //       <td style="border:1px solid black;text-align:center;padding:5px;white-space:nowrap">${this.datePipe.transform(doc.doc.customerRequestedDeliveryDate, 'yy-MM-dd')}</td>
        //     </tr>`

        //   })
        // });
        this.linkedOCs.forEach((doc, idx) => {
          html += `
            <tr style="border: 1px solid black">
              <td style="border:1px solid black;text-align:left;padding:5px">${getDocumentNumber(doc, null, false, false)}</td>
              <td style="border:1px solid black;text-align:left;padding:5px">${doc.customerDocumentNumber || ''}</td>
              <td style="border:1px solid black;text-align:center;padding:5px">${doc.pos}</td>
              <td style="border:1px solid black;text-align:right;padding:5px">${doc.quantity ?? ''}</td>
              <td style="border:1px solid black;text-align:center;padding:5px;white-space:nowrap">${this.datePipe.transform(doc.customerRequestedDeliveryDate, 'yy-MM-dd')}</td>
            </tr>`
        });
    
        html += `
      </table>
    </div>`

    this.data.copyHtmlToClipboard(html);

  }

  async downloadSimpleBoxTableXLS() {

    const boxes = JSON.parse(JSON.stringify(defaultReport.boxes));
    boxes.simple = true;
    let date = formatDate(Date.now(), 'yyMMdd', 'en_US');
    const customer = this.data.businesses.find(f => mongoId(f) === mongoId(this.compilation.customerReference))?.name;
    boxes.filename = `${date}_${customer}_${this.compilation.code}_Box info`
    boxes.doc = this.tree?.linkedOC?.code;
    this.documentComponent.reportsSearch = { boxes: boxes };
    this.documentComponent.cdRef.detectChanges();
    this.documentComponent.reportsPrinterRef.loading = true;
    this.documentComponent.reportsPrinterRef.pdfSidebar = false;
    await this.documentComponent.reportsPrinterRef.reloadData();
    await this.documentComponent.reportsPrinterRef.downloadExcel();
    this.documentComponent.reportsSearch = null;
    console.log(this.documentComponent.reportsPrinterRef);
  }

}
